module.exports = __webpack_public_path__ + "img/logo-full-competti-1.cbeabe53.png";